















































































import { checklistPostReq } from "@/services/checklist.service";

export default {
  props: ["cl_item"],
  data() {
    return {
      create_progress: false,
      checklist_dialog: {},
      create_error: false,
      database_entry: "",
      cl_entry: {},
      checkbox: true,
      select_user: [],
      select_company: [],
      select_view_company: [],
      select_machine_group: "internal", 
      items_user: [],
      items_company: [],
      items_machine_groups: ['public', 'internal'], 
      update_progress: false,
      status_saved: false,
    };
  },
  watch: {},
  computed: {
    appLang: function() {
      return this.$store.state.lang
    },
  },
  mounted() {
    checklistPostReq("checklist-settings", { uid: this.cl_item.uid })
      .then((resp) => {
        this.items_user = resp.data.user_list;
        this.items_company = resp.data.company_list;

        this.select_machine_group = resp.data.select_machine_group
        this.setUsers(resp.data.entry.user_list);
        this.setCompanies(resp.data.entry.company_list);
        console.log(resp.data);
      })
      .catch((e) => {
        //this.$store.dispatch("api_error", e);
      });
  },
  destroyed() {},
  methods: {
    setUsers: function (user_list) {
      this.select_user = [];
      if (user_list) {
        for (let k = 0; k < user_list.length; k++) {
          for (let m = 0; m < this.items_user.length; m++) {
            if (this.items_user[m].uid == user_list[k]) {
              console.log(this.items_user[m]);
              this.select_user.push({
                uid: this.items_user[m].uid,
                name: this.items_user[m].name,
              });
            }
          }
        }
      }
    },
    setCompanies: function (company_list) {
      this.select_company = [];
      if (company_list) {
        for (let k = 0; k < company_list.length; k++) {
          for (let m = 0; m < this.items_company.length; m++) {
            if (this.items_company[m].company_id == company_list[k]) {
              this.select_company.push({
                company_id: this.items_company[m].company_id,
                name: this.items_company[m].name 
              });
            }
          }
        }
      }
    },
    closeDialog: function () {
      this.$emit("dialogClosed", true);
    },
    save: function () {
      //if (!this.select_user || this.select_user.length == 0) {
      //  alert(this.$t('LABEL78'));
      //  return;
      //}

      this.update_progress = true;
      checklistPostReq("checklist-update-settings", {
        uid: this.cl_item.uid,
        select_user: this.select_user,
        select_company: this.select_company,
        //select_view_company: this.select_view_company,
        select_machine_group: this.select_machine_group,
      })
        .then((resp) => {
          this.update_progress = false;
          this.status_saved = true
        })
        .catch((e) => {
          this.$store.dispatch("api_error", e);
        });
    },
  },
};
